// Single source of truth for a farm's "location" (country): the option list shown
// in the farm-settings dropdown AND the flag rendered next to each farm in the list.
// `code` is what's persisted (farms.location, nullable; null/'' == "Not set").
import { t } from '../ui/lang';
/** "Not set" sentinel — the default, persisted as NULL / empty string. */
export const FARM_LOCATION_NONE = { code: '', label: t('nav.location_not_set'), flag: '' };
/** Selectable countries, in dropdown order (excluding the "Not set" option). */
export const FARM_COUNTRIES = [
    { code: 'DZ', label: t('nav.country_dz'), flag: '🇩🇿' },
    { code: 'AR', label: t('nav.country_ar'), flag: '🇦🇷' },
    { code: 'AU', label: t('nav.country_au'), flag: '🇦🇺' },
    { code: 'IN', label: t('nav.country_in'), flag: '🇮🇳' },
    { code: 'RU', label: t('nav.country_ru'), flag: '🇷🇺' },
    { code: 'TR', label: t('nav.country_tr'), flag: '🇹🇷' },
    { code: 'VE', label: t('nav.country_ve'), flag: '🇻🇪' },
    { code: 'CM', label: t('nav.country_cm'), flag: '🇨🇲' },
    { code: 'EG', label: t('nav.country_eg'), flag: '🇪🇬' },
    { code: 'KZ', label: t('nav.country_kz'), flag: '🇰🇿' },
    { code: 'UZ', label: t('nav.country_uz'), flag: '🇺🇿' },
];
/** Full option list for the <select>: "Not set" first, then the countries. */
export const FARM_LOCATION_OPTIONS = [FARM_LOCATION_NONE, ...FARM_COUNTRIES];
/** Resolve a stored code (nullable) to its FarmLocation, defaulting to "Not set". */
export function farmLocation(code) {
    if (!code)
        return FARM_LOCATION_NONE;
    return FARM_COUNTRIES.find((c) => c.code === code) ?? FARM_LOCATION_NONE;
}
/** Flag emoji for a stored code, or '' when unset/unknown. */
export function farmLocationFlag(code) {
    return farmLocation(code).flag;
}
